import { useEffect, useState, useRef } from "react";
import { Container, Box } from "@mui/material";
import GetAppButton from "../../components/GetAppButton";
import CustomText, { textStyles } from "../../components/CustomText";
import textUnderline from "../../assets/textUnderline.svg";
import more from "../../assets/more.svg";
import heroimage from "../../assets/heroimage.webp";
import { motion } from "framer-motion";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TeamBiometricSection from "./TeamBiometricSection";
import FeaturesCardsSection from "./FeaturesCardsSection";
import VisualImageSection from "./VisualImagesSection";
import IndustrySection from "./IndustrialSection";
import PricingSection from "./PricingSection";
import HappyTeamSection from "./HappyTeamSection";
import FAQsSection from "./FAQsSection";
import SubscribeSection from "./SubscribeSection";
import { useTranslation } from "react-i18next";
import Footer from "../../components/Footer";
import { Parallax } from "react-scroll-parallax";
import ParallaxItem from "../../components/ParallexSection";
import { ParallaxProvider } from "react-scroll-parallax";
import { useNavigate } from "react-router-dom";
import heroimagees from "../../assets/spanish/Home/heroimagees.webp";
import {BASE_URL} from "../../components/BASE_URL"

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSocialLinks } from "../../components/fetchGetAppUrl";

const HomePage = () => {
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  };
  const containerRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const calculateTextTransform = () => {
    const scale = Math.max(0.5, 1 - scrollY / 2000);
    const zTranslate = -scrollY * 0.5;
    return `perspective(1000px) scale(${scale}) translateZ(${zTranslate}px)`;
  };
  const calculateTextOpacity = () => {
    return Math.max(0, 1 - scrollY / 800);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isXs = useMediaQuery(theme.breakpoints.down("xs")); // usually <600px
  const isSm = useMediaQuery(theme.breakpoints.down("sm")); // <960px
  const isMd = useMediaQuery(theme.breakpoints.down("md")); // <1280px
  const isLg = useMediaQuery(theme.breakpoints.down("lg"));
  const { t, i18n } = useTranslation();
  useEffect(() => {
    console.log("Current language:", i18n.language);
  }, [i18n.language]);

  const isMobileS = useMediaQuery("(max-width: 320px)");
  const sectionMarginTop = isMobileS
    ? 600
    : isSm
      ? 420
      : isMd
        ? 150
        : isLg
          ? 150
          : 0;
  const sectionMarginBottom = isMobileS
    ? 550
    : isSm
      ? 360
      : isMd
        ? 150
        : isLg
          ? 150
          : 0;
  const navigate = useNavigate()
  const handleMore = () => {
    navigate("/product-tour")
  }
  const heroImageSrc = i18n.language === "es" ? heroimagees : heroimage;
    const [hero, setHero] = useState({
    title: "",
    description: "",
  });
  const [heroLoading, setHeroLoading] = useState(true);
  
  useEffect(() => {
  async function loadHero() {
    setHeroLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}/content/sections?page=1&limit=10&sort=order&search=Home&include=items`
      );
      const json = await res.json();
 console.log("home",json)
      const home = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home"
      );

      if (home?.items?.length) {
        // pick item based on current language
        const selectedItem =
          i18n.language === "es"
            ? home.items.find((item) => item.idx === 2) // Spanish
            : home.items.find((item) => item.idx === 0); // English

        setHero({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
        });
      }
    } catch (err) {
      console.error("Error loading hero section:", err);
    } finally {
      setHeroLoading(false);
    }
  }
  loadHero();
}, [i18n.language]); // <== reload when language changes


  const renderHighlightedTitle = (text) => {
  if (!text) return null;
  const words = text.trim().split(/\s+/);

  return words.map((word, index) => (
    <span
      key={index}
      style={index === 4 ? { color: "#1e88e5" } : undefined} // 5th word
    >
      {word}{" "}
    </span>
  ));
};
  const { links, loading } = useSocialLinks();
  return (
    <>
      <Box
        style={{
          backgroundColor: " #F8FFFF",
          marginTop: isMobile ? "90px" : "60px",
        }}
      >
        <Box
          ref={containerRef}
          sx={{
            mt: isMobile ? 0 : 0,
            pt: isMobile ? 0 : 4,
            px: isMobile ? 1 : 13,
            position: "relative",
            perspective: "1000px",
            perspectiveOrigin: "center",
            overflow: "hidden",
          }}
        >
      
          <div
            style={{
              position: "relative",
              zIndex: 2,
            }}
          >
            <CustomText
              style={{
                ...textStyles.h1,
                marginBottom: isMobile ? "0rem" : "1rem",
                marginTop: isMobile ? "0rem" : "1rem",
                fontSize: isMobile ? "40px" : "53px",
              }}
            >
      
                     {/* {hero.title || `${t("Keeps your team on")} ${t("track")} ${t("every day")}`} */}
                     {hero.title
  ? renderHighlightedTitle(hero.title)
  : `${t("Keeps your team on")} ${t("track")} ${t("every day")}`}
            </CustomText>

            <CustomText
              style={{
                ...textStyles.body1,
                color: "#868282",
                maxWidth: "1175px",
                margin: "0 auto",
                marginTop: "10px",
              }}
            >
                       {hero.description || t("hero_subtext")}
            </CustomText>
            <Box
              sx={{
                display: "flex",
                flexWrap: isMobile ? "wrap" : "nowrap",
                justifyContent: "center",
                alignItems: "center",
                mt: isMobile ? "5px" : 4,
                gap: 1,
              }}
            >
              <GetAppButton
                label={t("get_app_now")}
                variant="primary"
                size="large"
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 0,
                  cursor: "pointer",
                }}
                onClick={handleMore}
              >
                <img
                  src={more || "/placeholder.svg"}
                  style={{ width: "65px", height: "65px" }}
                />
                <p
                  style={{
                    color: hero_section_button_text.main,
                    fontSize: "18px",
                    fontWeight: 600,
                    fontFamily: "Poppins, sans-serif",

                  }}
                >
                  {t("Learn More")}
                </p>
              </Box>
            </Box>
          </div>
          {/* </motion.div> */}
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              width: "100%"
              // marginTop: "2rem",
              // background: 'radial-gradient(circle at right, rgba(0, 110, 194, 0.3) 0%, transparent 80%)'
            }}
          >
            <img
              src={heroImageSrc}
              alt="Hero"
              style={{

                marginTop: isMobile ? "20px" : "50px",
                width: "100%",
                height: isMobile ? "100%" : "540px",
                display: "block",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ px: 0 }}>

        <FeaturesCardsSection />
      </Box>
      <Box sx={{ backgroundColor: "white" }}>
        <TeamBiometricSection />
      </Box>
      <Box>
        <VisualImageSection />
      </Box>
      <Box
        sx={{
          backgroundColor: "white",
          pt: isMobile ? 0 : 15,
          py: isMobile ? 0 : 15,
          mt: isMobile ? 0 : `${sectionMarginTop}px`,
          mb: isMobile ? 0 : `${sectionMarginBottom}px`,
        }}
      >
        <IndustrySection />
      </Box>
      <Box>
        <PricingSection />
      </Box>
      <Box sx={{ backgroundColor: "#EFF4F8" }}>
        <HappyTeamSection />
      </Box>
      <Box
        sx={{
          backgroundColor: "#fff",
          pb: isMobile ? 0 : 13,
          mb: isMobile ? 0 : 0,
        }}
      >
        <FAQsSection />
      </Box>
      {/* <Box sx={{ mt: isMobile ? 0 : 0 }}>
        <SubscribeSection />
      </Box> */}
    </>
  );
};
export default HomePage;
